/**
 * Attendance Service - API client for daily student attendance
 */
import api from '../utils/api';

const attendanceService = {
  getClassAttendance: async (classId, attendanceDate) => {
    try {
      return await api.get(`/api/attendance/class/${classId}`, { params: { attendance_date: attendanceDate } });
    } catch (error) {
      console.error('Error fetching class attendance:', error);
      throw error;
    }
  },

  markAttendance: async (data) => {
    try {
      return await api.post('/api/attendance', data);
    } catch (error) {
      console.error('Error marking attendance:', error);
      throw error;
    }
  },

  updateAttendance: async (attendanceId, status, remarks = null) => {
    try {
      return await api.put(`/api/attendance/${attendanceId}`, { status, remarks });
    } catch (error) {
      console.error('Error updating attendance:', error);
      throw error;
    }
  },

  bulkMarkAttendance: async (payload) => {
    try {
      return await api.post('/api/attendance/bulk', payload);
    } catch (error) {
      console.error('Error bulk marking attendance:', error);
      throw error;
    }
  },

  getStudentAttendance: async (studentId, params = {}) => {
    try {
      return await api.get(`/api/attendance/student/${studentId}`, { params });
    } catch (error) {
      console.error('Error fetching student attendance:', error);
      throw error;
    }
  }
};

export default attendanceService;
